import { useOperatorsOrdersQuery } from '@/api/queries/operators';
import ComposedDrawerMenuAppBar from '@/components/ComposedDrawerMenuAppBar';
import { Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useParams } from 'react-router-dom';
import { OrderDetails, PageLoader, PriceDisplay } from 'remote/global';

function OrdersDetailView() {
  const { id } = useParams();
  const orderQuery = useOperatorsOrdersQuery(id!);
  const { data, isLoading, isError } = orderQuery;

  if (isLoading) return <PageLoader />;

  return (
    <>
      <ComposedDrawerMenuAppBar title={`#${id}`} />
      {isError && (
        <Box sx={{ p: 2 }}>
          <Typography>Order #{id} was not found</Typography>
        </Box>
      )}
      {!isError && data != null && (
        <Box sx={{ p: { xs: 1, md: 2 }, maxWidth: 600 }}>
          <Paper elevation={3}>
            <OrderDetails
              orderQuery={orderQuery}
              title={`#${id}`}
              header={{
                children:
                  orderQuery.data != null ? (
                    <PriceDisplay
                      priceExclVat={orderQuery.data.priceExclVat}
                      priceInclVat={orderQuery.data.priceInclVat}
                      unadjustedPriceExclVat={orderQuery.data.unadjustedPriceExclVat}
                      unadjustedPriceInclVat={orderQuery.data.unadjustedPriceInclVat}
                      clientListPriceInclVat={orderQuery.data.clientListPriceInclVat}
                      clientListPriceExclVat={orderQuery.data.clientListPriceExclVat}
                      currency={orderQuery.data.currency}
                      defaultValue
                    />
                  ) : undefined,
              }}
            />
          </Paper>
        </Box>
      )}
    </>
  );
}

export default OrdersDetailView;
